import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import { RolDefaultPermissions } from '../management-groups-permission.component';
import {
  Rol,
  RolPermisos,
  Base,
  PermisoPorTipo
} from '@app/shared';

@Injectable()
export class ManagementGroupsPermissionDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  /**
   * Consulta los permisos de los roles del sistema(grupos).
   *
   * @param {number} idGroup
   * @returns {Observable<RolPermisos>}
   * @memberof ManagementGroupsPermissionDataService
   */
  getRolesPermission(idGroup: number): Observable<RolPermisos> {
    return this.http.get<RolPermisos>(this.api.get('rolesPermissions', [idGroup]));
  }

  /**
   * Consulta los tipos de permisos en el sistema
   *
   * @returns {Observable<Base[]>}
   * @memberof ManagementGroupsPermissionDataService
   */
  getTypePermission(): Observable<Base[]> {
    return this.http.get<Base[]>(this.api.get('typePermissions'));
  }

  /**
   * Consulta los permisos del sistema por tipo
   *
   * @param {number} idType
   * @returns {Observable<PermisoPorTipo>}
   * @memberof ManagementGroupsPermissionDataService
   */
  getPermissionByType(idType: number): Observable<PermisoPorTipo> {
    return this.http.get<PermisoPorTipo>(this.api.get('typePermissions', [idType]));
  }

  /**
   * Agrega permisos a un grupo
   *
   * @param {RolDefaultPermissions} permission
   * @returns {Promise<boolean>}
   * @memberof ManagementGroupsPermissionDataService
   */
  addPermission(permission: RolDefaultPermissions): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:max-line-length
      this.http.skipErrorHandler().post<boolean>(this.api.get('rolesPermissions'), permission).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Permiso agregado correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            if (err.error['permiso']) {
              if (Array.isArray(err.error['permiso'])) {
                this.toastr.error(err.error['permiso'][0], 'Error de operacion');
              } else {
                this.toastr.error('Fallo del sistema', 'Error de operacion');
              }
            } else {
              this.toastr.error('Fallo del sistema', 'Error de operacion');
            }
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Elimina un permiso de un grupo
   *
   * @param {number} idRol
   * @param {Array<number>} idList
   * @returns {Promise<boolean>}
   * @memberof ManagementGroupsPermissionDataService
   */
  deletePermission(idRol: number, idList: Array<number>): Promise<boolean> {
    return new Promise((resolve, reject) => {
      // tslint:disable-next-line:max-line-length
      this.http.skipErrorHandler().put<boolean>(this.api.get('rolesPermissions', [idRol]), {permiso: idList}).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Permiso eliminado correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-groups-permission/shared/management-groups-permission.data.service.ts